// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"fd244d95","778":"aef87bec"}[chunkId] + ".chunk.js";
};